import Modal from '@/components/Modal';
import cn from '@/helpers/utils/classNames';

interface IVideoModal {
  video: string;
  onClose: () => void;
  isOpen: boolean;
  className?: string;
  closeBtnClassName?: string;
}
const VideoModal = ({ video, onClose, isOpen, className, closeBtnClassName }: IVideoModal) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={cn('bg-transparent py-4 shadow-none', className)}
      placement="top-center"
      closeIconBtnClassName={cn(closeBtnClassName)}
      closeBtnClassName="video-modal-close-btn -top-[2px] right-[62px] h-[30px] w-[30px] rounded-full !bg-primary bg-lime-500 pt-[2px] text-white outline-none hover:border-transparent"
    >
      <div className="flex h-full items-center justify-center">
        <iframe
          src={video}
          title="Pawtree Intro Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="mx-3 h-[350px] sm:w-screen md:w-[800px] lg:w-[880px] xl:w-[880px]"
        ></iframe>
      </div>
    </Modal>
  );
};

export default VideoModal;
